import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { CreateAgencyRequest } from "@shared/lib/types/agency";

export function useCreateAgency() {
  const {
    mutate: createAgency,
    isLoading: isCreating,
    isSuccess: isCreated,
    isError,
  } = useMutation<CreateAgencyRequest>({
    mutationFn: (agency) =>
      AgencyService.createAgency(agency).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY, // Use the imported constant
      skipInvalidation: false,
    },
  });

  return {
    createAgency,
    isCreating,
    isCreated,
  };
}
